(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      /* Transparent header: only activate if the page has a hero section */
      this.isTransparent = false;
      if (this.hasAttribute('data-transparent-header')) {
        const heroSection = document.querySelector('[data-hero-section]');
        if (heroSection) {
          this.isTransparent = true;
          const textVariant = this.getAttribute('data-transparent-text') || 'white';
          this.classList.add('header-wrapper--transparent', 'header-wrapper--transparent-' + textVariant);
        } else {
          /* No hero on this page (e.g. PDP, collection) — strip transparent classes rendered into HTML */
          this.classList.remove('header-wrapper--transparent', 'header-wrapper--transparent-white', 'header-wrapper--transparent-navy');
        }
      }

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.glassEnabled = this.classList.contains('header-wrapper--glass-enabled');
      this.updateGlassState();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      // Measure the sticky-header element itself, not .section-header: with the
      // transparent-header CLS fix the section wrapper is always 0-height (the
      // header-wrapper is position:absolute), so measuring it would publish
      // --header-height: 0 and break scroll-margin-top anchors. (2026-06-23)
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* Transparent header toggle, works independently of sticky type */
      if (this.isTransparent) {
        if (scrollTop > 50) {
          this.classList.remove('header-wrapper--transparent');
          this.classList.add('header-wrapper--solid');
        } else {
          this.classList.add('header-wrapper--transparent');
          this.classList.remove('header-wrapper--solid');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventReveal === false) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      this.updateGlassState(scrollTop);
    }

    updateGlassState(scrollTop = window.pageYOffset || document.documentElement.scrollTop) {
      if (this.glassEnabled === false) return;

      this.classList.toggle(
        'is-glass',
        scrollTop > 0 && this.header.classList.contains('shopify-section-header-hidden') === false
      );
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.updateGlassState();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.updateGlassState();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.updateGlassState();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-video-carousel"] && !Shopify.designMode) return;
  try {
    
  class NpVideoCarousel extends HTMLElement {
    connectedCallback() {
      if (this._npBound) return;
      this._npBound = true;

      this._track = this.querySelector('.np-vc__track');
      this._dots = [...this.querySelectorAll('.np-vc__dot')];

      this.querySelectorAll('.np-vc__play-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const wrap = btn.closest('.np-vc__play-wrap');
          const video = wrap ? wrap.querySelector('.np-vc__video') : null;
          if (wrap && wrap._npInit && video && wrap.dataset.type === 'video') {
            if (video.paused) { video.style.display = 'block'; video.play().catch(() => {}); } else { video.pause(); }
          } else {
            this._onPlay(btn);
          }
        });
      });

      this._dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this._goTo(parseInt(dot.dataset.index, 10));
        });
      });

      if (this._track) {
        this._track.addEventListener('scroll', () => this._syncDots(), { passive: true });
      }
    }

    _onPlay(btn) {
      const wrap = btn.closest('.np-vc__play-wrap');
      if (!wrap) return;
      const type = wrap.dataset.type;

      if (type === 'video') {
        const video = wrap.querySelector('.np-vc__video');
        const overlay = wrap.querySelector('.np-vc__overlay');
        const poster = wrap.querySelector('.np-vc__poster');
        if (!video) return;

        if (!wrap._npInit) {
          wrap._npInit = true;

          video.addEventListener('click', () => { if (!video.paused) { video.pause(); } else { video.play().catch(() => {}); } });

          video.addEventListener('play', () => {
            video.style.display = 'block';
            btn.setAttribute('aria-label', 'Pause video');
            btn.setAttribute('aria-pressed', 'true');
            wrap.classList.add('np-vc__play-wrap--playing');
            if (poster) poster.style.display = 'none';
            if (overlay) overlay.style.display = 'none';
          });

          video.addEventListener('pause', () => {
            if (!video.ended) {
              btn.setAttribute('aria-label', 'Play video');
              btn.setAttribute('aria-pressed', 'false');
              if (overlay) overlay.style.display = '';
              wrap.classList.remove('np-vc__play-wrap--playing');
            }
          });

          video.addEventListener('ended', () => {
            video.style.display = 'none';
            video.currentTime = 0;
            if (poster) poster.style.display = '';
            btn.setAttribute('aria-label', 'Play video');
            btn.setAttribute('aria-pressed', 'false');
            if (overlay) overlay.style.display = '';
            wrap.classList.remove('np-vc__play-wrap--playing');
          });
        }

        // video.style.display is set before play() (not left to the 'play'
        // listener) because a display:none element may not reliably start
        // playback in some browsers. Poster/overlay hiding is handled by
        // the persistent 'play' listener above so it re-applies on replay.
        video.style.display = 'block';
        video.play().catch(() => {});
      } else if (type === 'youtube') {
        const ytId = wrap.dataset.ytId;
        if (!ytId) return;
        const iframe = document.createElement('iframe');
        iframe.className = 'np-vc__iframe';
        iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = 'YouTube video';
        wrap.innerHTML = '';
        wrap.appendChild(iframe);
      }
    }

    _syncDots() {
      if (!this._track || this._dots.length === 0) return;
      const slides = [...this._track.querySelectorAll('.np-vc__slide')];
      if (!slides.length) return;
      const trackRect = this._track.getBoundingClientRect();
      const trackMid = trackRect.left + trackRect.width / 2;
      let closestIdx = 0;
      let closestDist = Infinity;
      slides.forEach((slide, i) => {
        const rect = slide.getBoundingClientRect();
        const dist = Math.abs(rect.left + rect.width / 2 - trackMid);
        if (dist < closestDist) { closestDist = dist; closestIdx = i; }
      });
      this._dots.forEach((dot, i) => {
        const active = i === closestIdx;
        dot.classList.toggle('np-vc__dot--active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    _goTo(idx) {
      const slides = this._track ? [...this._track.querySelectorAll('.np-vc__slide')] : [];
      if (!slides[idx] || !this._track) return;
      const trackRect = this._track.getBoundingClientRect();
      const slideRect = slides[idx].getBoundingClientRect();
      this._track.scrollTo({
        left: this._track.scrollLeft + (slideRect.left - trackRect.left),
        behavior: 'smooth'
      });
    }
  }
  if (!customElements.get('np-video-carousel')) {
    customElements.define('np-video-carousel', NpVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
